<template>
  <div class="w-100">
    <div class="header d-flex align-items-center w-100 justify-content-between">
      <p class="header-title mb-0">Other expenses</p>
      <p class="header-title mb-0">
        {{ NumberFormatter(otherExpenses($route)) }}
      </p>
    </div>
    <ClickableInputWithPopUp
      v-for="(item, index) in modelData"
      :key="item.model"
      :model-name="item.model"
      :name="item.name"
      :sub="item.sub"
      :show-input="item.showInput"
      :show-popup="item.showPopup"
      :on-tab-and-enter="handleTabEnter"
      :bg-color="!index || !(index % 2) ? 'white' : 'gray'"
    />
    <EditableSheet
      v-if="$route.query.business !== 'master'"
      data-key="additional_other_expenses"
      button-name="Add Other Expenses"
    />
    <CustomClickableInput
      v-else
      v-model="groupData['additional_other_expenses']"
      :disabled="true"
      name="Additional Other Expenses"
    />
    <div class="header d-flex align-items-center w-100 justify-content-between">
      <p class="header-title mb-0">
        Earning before Interest, Tax Depreciation & Amortization (EBITDA)
      </p>
      <p class="header-title mb-0">
        {{ NumberFormatter(earningBeforeInterest($route)) }}
      </p>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { nonIfrsOtheExpenseData } from "./data";
import { storeToRefs } from "pinia";
import { useNoneIFRSProfitLoss } from "../../../../../store/NonIFRS/profitLoss.store";
import EditableSheet from "../common/EditableSheet.vue";
import { NumberFormatter } from "../../../../../helpers/numberFormatter";
import ClickableInputWithPopUp from "./InputWithPop.vue";
import { HandleTabAndEnter } from "./helper";
import { CustomClickableInput } from "../../../../common";

const modelData = ref(nonIfrsOtheExpenseData);
const nonIfrsPlStore = useNoneIFRSProfitLoss();
const { data, otherExpenses, earningBeforeInterest, groupData } =
  storeToRefs(nonIfrsPlStore);

const handleTabEnter = async (model) => {
  HandleTabAndEnter(data, modelData, model);
};
</script>

<style scoped>
.header {
  min-height: 44px;
  background: #0f75bc;
  padding-right: 100px;
  padding-left: 10px;
}

.header-title {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.055em;
  color: #fafbff;
}

.table-body {
  min-height: 44px;
  padding-right: 100px;
  padding-left: 26px;
}

.body-title {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  letter-spacing: 0.055em;
  color: #382628;
}

.white {
  background: #fafbff;
}

.gray {
  background: #deeded;
}

.table-body.sub {
  padding-left: 46px;
}
.total-container {
  min-height: 76px;
  border-top: 1px solid #747171;
  background: #fafbff;
  padding-right: 100px;
  padding-left: 10px;
}
.total-amount {
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  text-transform: uppercase;
  color: #000000;
}
.grand-total {
  height: 75px;
  background: #0f75bc;
  padding-right: 100px;
  padding-left: 10px;
}
.grand-total-amount {
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.055em;
  text-transform: uppercase;
  color: #fafbff;
}
.white {
  background: #fafbff;
}

.gray {
  background: #deeded;
}
</style>
